<template>
  <div class="line-item-picker">
    <label v-if="label" class="line-item-picker__label">{{ label }}</label>
    <v-list dense class="line-item-picker__list">
      <v-list-item
        v-for="(item, idx) in items"
        :key="getItemKey(item, idx)"
        class="line-item-picker__item"
        :class="{ 'line-item-picker__item--active': value === idx }"
        @click="$emit('input', idx)"
      >
        <v-list-item-content>
          <v-list-item-title class="line-item-picker__title">
            {{ getItemLabel(item) }}
          </v-list-item-title>
        </v-list-item-content>
        <v-icon v-if="value === idx" small class="line-item-picker__check">mdi-check</v-icon>
      </v-list-item>
      <p v-if="!items.length" class="line-item-picker__empty">{{ emptyText }}</p>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'LineItemPicker',
  props: {
    /** Section label (e.g. "Line item") */
    label: { type: String, default: '' },
    /** Array of items to list */
    items: { type: Array, default: () => [] },
    /** Selected index (v-model) */
    value: { type: Number, default: 0 },
    /** Property name(s) to use as display label; first found wins. Default: title, name */
    itemLabelKeys: { type: Array, default: () => ['title', 'name'] },
    /** Text when items array is empty */
    emptyText: { type: String, default: 'No items' },
  },
  methods: {
    getItemKey(item, idx) {
      return item?.id != null ? item.id : `item-${idx}`
    },
    getItemLabel(item) {
      if (!item || typeof item !== 'object') return 'Item'
      for (const key of this.itemLabelKeys) {
        const v = item[key]
        if (v != null && String(v).trim() !== '') return String(v).trim()
      }
      return 'Item'
    },
  },
}
</script>

<style scoped>
.line-item-picker__label {
  display: block;
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.45);
  margin-bottom: 6px;
  cursor: default;
}

.line-item-picker__list {
  max-height: 100px;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 2px 0;
}

.line-item-picker__item {
  cursor: pointer;
  min-height: 32px !important;
  padding: 0 8px 0 10px !important;
  margin: 0 4px;
  border-radius: 6px;
  border-left: 3px solid transparent;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.line-item-picker__item >>> .v-list-item__content {
  padding: 2px 0;
}

.line-item-picker__item >>> .v-list-item__action {
  min-width: 24px;
  margin-right: 0;
}

.line-item-picker__item:hover {
  background: rgba(255, 255, 255, 0.05) !important;
}

.line-item-picker__item--active {
  background: rgba(26, 115, 232, 0.08) !important;
  border-left-color: rgb(26, 115, 232);
}

.line-item-picker__item--active .line-item-picker__title {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 500;
}

.line-item-picker__check {
  color: rgb(26, 115, 232) !important;
}

.line-item-picker__title {
  font-size: 0.8125rem !important;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.3;
}

.line-item-picker__empty {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.35);
  padding: 8px 12px;
  font-style: italic;
  margin: 0;
}
</style>
